function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M100 100H0V57.707l28.125-18.543v15.832l23.957-16.039v15.832l23.957-15.832v15.832L100 38.957zM4.168 95.832h91.668l-.004-48.957-23.957 15.832V46.875L47.918 62.707V46.875L23.961 62.707V46.875L4.168 59.793z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.293 51.043L77.5 4.168h-8.125l-4.582 45.414-4.168-.414 5-49.168H81.25l5.207 50.625zM11.668 73.125h4.168v5.625h-4.168zM22.293 73.125h4.168v5.625h-4.168zM33.125 73.125h4.168v5.625h-4.168zM43.957 73.125h4.168v5.625h-4.168zM54.582 73.125h4.168v5.625h-4.168zM65.418 73.125h4.168v5.625h-4.168zM76.043 73.125h4.168v5.625h-4.168z"
});

function SvgIconUsine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
}

export default SvgIconUsine;